var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "jobdescription"
    }
  }, [_c('confirm-delete-popup', {
    attrs: {
      "popup-state": _vm.confirmDeleteDesc,
      "warning-condition": _vm.postesCount > 0
    },
    on: {
      "close": function ($event) {
        return _vm.changeDeletePopupState(-1);
      },
      "confirmation": function ($event) {
        return _vm.deleteDesc(_vm.toDelete);
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n      Supprimer\n      " + _vm._s(_vm.isJobDescriptionType ? 'la fiche de poste' : 'le référentiel de formation') + "\n      "), _c('br'), _vm._v("\"" + _vm._s((_vm.toDelete || {}).name) + "\"\n    ")];
      },
      proxy: true
    }, {
      key: "message",
      fn: function () {
        return [_vm._v("\n      Êtes-vous sûr de vouloir supprimer\n      " + _vm._s(_vm.isJobDescriptionType ? 'la fiche de poste' : 'le référentiel de formation') + "\n      "), _c('br'), _vm._v("\n      \"" + _vm._s((_vm.toDelete || {}).name) + "\" ?\n    ")];
      },
      proxy: true
    }, {
      key: "warning",
      fn: function () {
        return [_vm._v("\n      Attention\n      " + _vm._s(_vm.isJobDescriptionType ? 'cette fiche de poste est utilisée' : 'ce référentiel est utilisé') + "\n      pour " + _vm._s(_vm.postesCount) + " " + _vm._s(_vm.isJobDescriptionType ? 'poste' : 'formation') + _vm._s(_vm.postesCount === 1 ? '' : 's') + ".\n    ")];
      },
      proxy: true
    }, {
      key: "confirmTitle",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.isJobDescriptionType ? 'Fiche de poste supprimée' : 'Référentiel de formation supprimé') + "\n    ")];
      },
      proxy: true
    }, {
      key: "confirmMessage",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.isJobDescriptionType ? 'La fiche de poste' : 'Le référentiel') + "\n      \"" + _vm._s((_vm.toDelete || {}).name) + "\" a bien été supprimé" + _vm._s(_vm.isJobDescriptionType ? 'e' : '') + ".\n    ")];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.transferSuccess
    },
    on: {
      "close": function ($event) {
        return _vm.changeTransferSuccessPopupState(false);
      }
    }
  }, [_c('div', {
    staticClass: "mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "mb-10 text-pink-600"
  }, [_vm._v("\n        " + _vm._s(_vm.isJobDescriptionType ? 'Fiche de poste ajoutée' : 'Référentiel de formation ajouté') + "\n        !\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-10"
  }, [_vm._v("\n        " + _vm._s(_vm.isJobDescriptionType ? 'La fiche de poste' : 'Le référentiel de formation') + "\n        « " + _vm._s(_vm.transferedDesc) + " » a bien été ajouté" + _vm._s(_vm.isJobDescriptionType ? 'e' : '') + "\n        à votre bibliothèque personnelle.\n        " + _vm._s(!_vm.$freeParticulier() ? 'Vous pouvez désormais la personnaliser.' : '') + "\n      ")]), _vm._v(" "), _c('illustration', {
    staticClass: "mt-12 mx-auto",
    attrs: {
      "name": "basket"
    }
  })], 1)]), _vm._v(" "), _c('popup-job-desc', {
    attrs: {
      "id": _vm.shownJobId,
      "show": _vm.showJobDesc,
      "opened-from-edit-button": _vm.openFromEditButton && _vm.permissions.persoEdit
    },
    on: {
      "mutateShow": function (newValue) {
        _vm.showJobDesc = newValue;
        !newValue && _vm.openFromEditButton ? _vm.load_descs(true) : null;
      },
      "mutateId": function (newValue) {
        _vm.shownJobId = newValue;
      }
    }
  }), _vm._v(" "), _c('popup-ref-formation', {
    attrs: {
      "id": _vm.shownJobId,
      "show": _vm.showRefForm,
      "opened-from-edit-button": _vm.openFromEditButton && _vm.permissions.persoEdit
    },
    on: {
      "mutateShow": function (newValue) {
        _vm.showRefForm = newValue;
        !newValue && _vm.openFromEditButton ? _vm.load_descs(true) : null;
      },
      "mutateId": function (newValue) {
        _vm.shownJobId = newValue;
      }
    }
  }), _vm._v(" "), _c('popup-rome-desc', {
    attrs: {
      "id": _vm.shownJobId,
      "show": _vm.showRomeDesc,
      "opened-from-edit-button": _vm.openFromEditButton && _vm.permissions.persoEdit
    },
    on: {
      "mutateShow": function (newValue) {
        _vm.showRomeDesc = newValue;
        !newValue && _vm.openFromEditButton ? _vm.load_descs(true) : null;
      },
      "mutateId": function (newValue) {
        _vm.shownJobId = newValue;
      }
    }
  }), _vm._v(" "), _c('module-header', {
    attrs: {
      "module-name": _vm.isJobDescriptionType ? 'Fiches de poste' : 'Référentiels de formation',
      "illustration-name": "fiche_de_poste"
    },
    scopedSlots: _vm._u([{
      key: "description",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.isJobDescriptionType ? 'Retrouvez dans la bibliothèque commune des fiches de poste' : 'Retrouvez ici les référentiels de formation.') + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.isJobDescriptionType ? 'et importez celles qui correspondent à votre structure dans votre bibliothèque personnelle.' : 'Vous pouvez en créer de nouveaux, les modifier, ou en importer depuis la bibliothèque commune.') + "\n    ")];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.restrictedDescsPopup
    },
    on: {
      "close": function ($event) {
        _vm.restrictedDescsPopup = false;
      }
    }
  }, [_c('div', {
    staticClass: "my-4 mx-6"
  }, [_c('p', [_vm._v("\n        Pour accéder à l'ensemble des fiches disponibles dans la bibliothèque commune,\n        "), _c('router-link', {
    staticClass: "underline text-indigo-600",
    attrs: {
      "to": {
        name: 'Subscriptionchoice'
      }
    }
  }, [_vm._v("\n          faites évoluer votre abonnement.\n        ")])], 1)])]), _vm._v(" "), _vm.allowed && (_vm.permissions.persoList || _vm.permissions.commonList) ? _c('div', [_c('div', {
    staticClass: "flex space-x-10 mt-16 mb-16 items-center"
  }, [_vm.permissions.persoAddNew && _vm.personalLibrary ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-indigo-200",
      "icon-color": "text-indigo-600",
      "libelle": 'Ajouter ' + (_vm.isJobDescriptionType ? 'une fiche de poste' : 'un référentiel de formation') + ' vierge',
      "icon": "plus",
      "responsive": ""
    },
    on: {
      "clickAction": function ($event) {
        return _vm.new_desc();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.permissions.commonAddNew && !_vm.personalLibrary ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-indigo-200",
      "icon-color": "text-indigo-600",
      "libelle": 'Ajouter ' + (_vm.isJobDescriptionType ? 'une fiche de poste' : 'un référentiel de formation') + ' vierge',
      "icon": "plus",
      "responsive": ""
    },
    on: {
      "clickAction": function ($event) {
        return _vm.new_desc();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.permissions.persoDownloadModel && _vm.isJobDescriptionType ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-teal-300",
      "bg-color-square": "bg-teal-100",
      "icon-color": "text-teal-600",
      "libelle": "Télécharger le modèle de fiche",
      "icon": "download",
      "responsive": ""
    },
    on: {
      "clickAction": function ($event) {
        return _vm.download('/resources/', 'Modele_fiche_de_poste.doc');
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.permissions.persoDownloadInstructions && _vm.isJobDescriptionType ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-pink-300",
      "bg-color-square": "bg-pink-100",
      "icon-color": "text-pink-600",
      "libelle": "Télécharger la notice fiche de poste",
      "icon": "file-text",
      "responsive": ""
    },
    on: {
      "clickAction": function ($event) {
        return _vm.download('/resources/', 'Formalisation_fiche_de_poste.pdf');
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "relative flex flex-col align-middle min-w-full shadow rounded-xl bg-white min-h-screen",
    attrs: {
      "id": "jobdescs"
    }
  }, [_c('div', {
    staticClass: "flex flex-col"
  }, [_c('h3', {
    staticClass: "my-5 lg:my-15 2xl:my-20 w-full"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center space-x-3"
  }, [_vm.permissions.commonList && _vm.permissions.persoList && _vm.navBarScrolledRight ? _c('div', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.scrollLibraryTypeTab('left');
      }
    }
  }, [_c('icon', {
    staticClass: "text-indigo-600 md:hidden block transform rotate-180",
    attrs: {
      "name": "arrow-right_1"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "flex justify-between md:justify-center md:space-x-10 text-gray-600 cursor-pointer text-center overflow-x-auto w-2/3 md:w-full",
    attrs: {
      "id": "jobDescriptionLibraryTypeTabs"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm.permissions.persoList ? _c('h4', {
    staticClass: "text-gray-600 flex-shrink-0 w-max cursor-pointer font-light hover:text-pink-600",
    class: {
      'text-indigo-600 font-normal': _vm.personalLibrary
    },
    attrs: {
      "id": "tour_personal_library"
    },
    on: {
      "click": function ($event) {
        return _vm.changeLibrary(true);
      }
    }
  }, [_vm._v("\n              Bibliothèque personnelle\n            ")]) : _vm._e(), _vm._v(" "), _vm.permissions.commonList ? _c('h4', {
    staticClass: "text-gray-600 flex-shrink-0 w-max cursor-pointer font-light hover:text-pink-600 pl-4 md:pl-0",
    class: {
      'text-indigo-600 font-normal': !_vm.personalLibrary
    },
    attrs: {
      "id": "tour_shared_library"
    },
    on: {
      "click": function ($event) {
        return _vm.changeLibrary(false);
      }
    }
  }, [_vm._v("\n              Bibliothèque commune\n            ")]) : _vm._e()]), _vm._v(" "), _vm.permissions.commonList && _vm.permissions.persoList && !_vm.navBarScrolledRight ? _c('div', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.scrollLibraryTypeTab('right');
      }
    }
  }, [_c('icon', {
    staticClass: "text-indigo-600 md:hidden block",
    attrs: {
      "name": "arrow-right_1"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center justify-center my-5 space-y-5"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full px-5 mb-2",
    attrs: {
      "id": "search_filter_container"
    }
  }, [_c('div', {
    staticClass: "relative flex justify-start tour_fiches_postes_filtrer"
  }, [_c('div', {
    staticClass: "flex justify-start items-center cursor-pointer"
  }, [_c('div', {
    staticClass: "flex justify-start items-center cursor-pointer",
    on: {
      "click": [_vm.displayFilter, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_c('div', {
    staticClass: "bg-teal-300 text-teal-600 max-h-8 rounded-full inline-flex items-center p-2"
  }, [_c('icon', {
    staticClass: "h-4 w-4",
    attrs: {
      "name": "height"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:flex items-center mx-2"
  }, [_c('p', {
    staticClass: "text-lg text-gray-900 text-center select-none"
  }, [_vm._v("\n                    Filtrer les\n                    " + _vm._s(_vm.isJobDescriptionType ? 'fiches de poste' : 'référentiels de formation') + "\n                  ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.searchSector || _vm.searchFamily,
      expression: "searchSector || searchFamily"
    }],
    staticClass: "text-sm text-pink-600 cursor-pointer",
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n                Supprimer les filtres\n              ")])]), _vm._v(" "), _vm.showFilter ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayFilter,
      expression: "displayFilter"
    }],
    staticClass: "filterbox z-40 absolute rounded-md bg-white shadow-md shadow-gray-600 text-base top-14 py-5 pl-5 pr-8 min-w-max"
  }, [_c('div', {
    staticClass: "grid grid-cols-2 gap-y-2 lg:gap-y-0 lg:gap-x-4 min-w-max"
  }, [_c('input-select', {
    staticClass: "lg:col-span-1",
    attrs: {
      "name": "sector",
      "libelle": "Secteur d'activité",
      "datas": _vm.categories,
      "value": _vm.searchSector
    },
    on: {
      "input": function (newValue) {
        _vm.searchSector = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-span-1",
    attrs: {
      "name": "family",
      "libelle": "Famille professionnelle",
      "datas": _vm.listFamilies
    },
    on: {
      "input": function (newValue) {
        _vm.searchFamily = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-start-1",
    attrs: {
      "name": "resource",
      "libelle": "Ressource",
      "datas": [{
        value: 'Tout'
      }, {
        value: 'Neopass'
      }, {
        value: 'ROME'
      }],
      "value": _vm.resourceFilter
    },
    on: {
      "input": function (newValue) {
        return _vm.resourceFilter = newValue;
      }
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-2/3 sm:w-1/3",
    attrs: {
      "id": "search_bar_container"
    },
    on: {
      "keydown": _vm.onKeyDown,
      "keyup": _vm.onKeyUp
    }
  }, [_c('search-bar', {
    attrs: {
      "name": "searchBeneficiary",
      "libelle": "",
      "value": _vm.search,
      "placeholder": 'Rechercher ' + (_vm.isJobDescriptionType ? 'une fiche' : 'un référentiel'),
      "big": false,
      "inherits": false,
      "has-border": false
    },
    on: {
      "input": function (newValue) {
        _vm.search = newValue;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-full px-5 flex items-center justify-end",
    attrs: {
      "id": "sort_button_container"
    },
    on: {
      "keydown": _vm.onKeyDown,
      "keyup": _vm.onKeyUp
    }
  }, [_c('sort-button', {
    attrs: {
      "sort": _vm.sort
    },
    on: {
      "sorted": function (sortType) {
        _vm.sort = sortType;
      }
    }
  })], 1)]), _vm._v(" "), _vm.sortedSheets.length > 0 ? _c('SheetList', {
    attrs: {
      "sheets": _vm.sortedSheets,
      "personal-library": _vm.personalLibrary
    },
    on: {
      "showSheet": function (_ref) {
        var sheet = _ref[0],
          editMode = _ref[1];
        return _vm.openModal(sheet, editMode);
      },
      "displayDis": function ($event) {
        _vm.restrictedDescsPopup = true;
      },
      "export": _vm.exporter,
      "delete": _vm.showDeletePopup,
      "duplicate": _vm.duplicate,
      "import": function (sheet) {
        return _vm.addToPersonalLibrary(sheet.id);
      }
    }
  }) : !_vm.loading && _vm.listSheets.length === 0 && _vm.hasSearch ? _c('div', {
    staticClass: "flex flex-col justify-center items-center w-full"
  }, [_c('h3', {
    staticClass: "text-pink-600 w-full text-center font-semibold text-lg mt-12"
  }, [_vm._v("\n          Aucun résultat !\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "text-indigo-600 w-4/6 inputfloat text-center text-base mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.isJobDescriptionType ? 'Aucune fiche de poste' : 'Aucun référentiel de formation') + "\n          ne correspond à votre recherche, veuillez réessayer avec de nouveaux\n          éléments\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 mb-8"
  }, [_c('illustration', {
    attrs: {
      "name": "no_result"
    }
  })], 1)]) : !_vm.loading && _vm.listSheets.length === 0 ? _c('div', {
    staticClass: "flex flex-col justify-center items-center w-full"
  }, [_c('h6', {
    staticClass: "text-pink-600 w-full text-center mt-12 mb-8"
  }, [_vm._v("\n          " + _vm._s(_vm.isJobDescriptionType ? 'Aucune fiche de poste' : 'Aucun référentiel de formation') + "\n          !\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-indigo-600 w-4/6 text-center text-base"
  }, [_vm._v("\n          Vous n'avez\n          " + _vm._s(_vm.isJobDescriptionType ? 'aucune fiche de poste' : 'aucun référentiel de formation') + "\n          "), !_vm.personalLibrary ? _c('span', [_vm._v("dans votre bibliothèque commune")]) : _vm._e(), _vm._v(" "), _vm.personalLibrary && (_vm.permissions.persoAddNew || _vm.permissions.commonAddToPerso) || !_vm.personalLibrary && _vm.permissions.commonAddNew ? _c('span', [_vm._v(", vous pouvez\n          ")]) : _vm._e(), _vm._v(" "), _vm.permissions.persoAddNew && _vm.personalLibrary || _vm.permissions.commonAddNew && !_vm.personalLibrary ? _c('span', [_vm._v("en créer une nouvelle")]) : _vm._e(), _vm._v(" "), _vm.personalLibrary && _vm.permissions.persoAddNew && _vm.permissions.commonAddToPerso ? _c('span', [_vm._v("\n            ou")]) : _vm._e(), _vm._v(" "), _vm.personalLibrary && _vm.permissions.commonAddToPerso ? _c('span', [_vm._v("\n            en importer depuis la bibliothèque commune")]) : _vm._e(), _vm._v(".\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 mb-8"
  }, [_c('illustration', {
    attrs: {
      "name": "no_result"
    }
  })], 1)]) : _vm._e()], 1)]) : _c('page-not-allowed')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }